import React, { Component } from 'react';
import ComTable from '../ComTable';

class TrainingExp extends Component {
    state = {
        config: [],
        loading: false,
    }

    componentDidMount() {
        const config = [{
            zh: '培训内容',
            en: 'Training Content',
            key: 'trainingContentShow',
            width: 500,
        }, {
            zh: '培训时间',
            en: 'Training Date',
            key: 'startTimeShow',
        }];
        this.setState({ config });
    }

    getDataSource = () => {
        const { data, isChinese } = this.props;
        const dataSource = data.map((item, index) => {
            const {
                startTime,
                endTime,
                trainingContent,
                trainingContentEnglish,
                trainingCommentsChinese,
                trainingCommentsEnglish,
            } = item;
            const trainingComments = isChinese ? trainingCommentsChinese : trainingCommentsEnglish;
            return {
                index: index + 1,
                ...item,
                trainingContentShow: `${isChinese ? trainingContent : trainingContentEnglish}${trainingComments ? `(${trainingComments})` : ''}`,
                startTimeShow: `${startTime.slice(0, 7)}~${endTime ? endTime.slice(0, 7) : isChinese ? '至今' : 'Present'}`,
            }
        });
        return dataSource;
    }

    render() {
        const { isChinese } = this.props;
        const { config, loading } = this.state;
        const result = config.map(item => {
            if (isChinese) {
                item.title = item.zh;
            } else {
                item.title = item.en;
            }
            return item;
        });
        return (
            <ComTable
                config={result}
                loading={loading}
                pagination={false}
                getDataSource={this.getDataSource}
            />
        );
    }
}

export default TrainingExp;


// WEBPACK FOOTER //
// ./src/components/common/generateCurriculumVitae/TrainingExp.js